import { responsiveWrapper } from 'react-responsive-redux';

export const MobileScreen = responsiveWrapper({ maxWidth: 767 });
export const DesktopScreen = responsiveWrapper({ minWidth: 768 });



// WEBPACK FOOTER //
// ./src/components/ResponsiveScreens/ResponsiveScreens.js